import CrudCustom from '../../../libs/custom/CrudCustom';

let KelompokAsetService = new CrudCustom('/kelompok-asets');
export default KelompokAsetService;
